import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateComponent, selectSelectedComponent } from '../../../redux/editorSlice';
import { usePropertyPanel } from '../PropertyPanelContext';
import { PaddingControl } from '../CommonProperties';

const FAQProperties = () => {
  // 선택된 컴포넌트 가져오기
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();
  
  // 컨텍스트에서 필요한 함수들 가져오기
  const { handleStyleChange } = usePropertyPanel();
  
  // FAQ 아이템 관리 기능
  const handleFAQItemChange = (index, field, value) => {
    const updatedItems = [...(selectedComponent.faqItems || [])];
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: value
    };
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        faqItems: updatedItems
      }
    }));
  };
  
  const handleAddFAQItem = () => {
    const updatedItems = [
      ...(selectedComponent.faqItems || []),
      { question: '새 질문', answer: '새 답변' }
    ];
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        faqItems: updatedItems
      }
    }));
  };
  
  const handleRemoveFAQItem = (index) => {
    const updatedItems = [...(selectedComponent.faqItems || [])];
    updatedItems.splice(index, 1);
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        faqItems: updatedItems
      }
    }));
  };
  
  // FAQ 제목 변경 핸들러
  const handleTitleChange = (value) => {
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        title: value
      }
    }));
  };
  
  // 스타일 변경 핸들러
  const handleTitleStyleChange = (property, value) => {
    if (!selectedComponent) return;
    
    const existingStyle = JSON.parse(JSON.stringify(selectedComponent.style || {}));
    
    // titleStyle 속성 초기화 (필요시)
    if (!existingStyle.titleStyle) {
      existingStyle.titleStyle = {};
    }
    
    // titleStyle 속성 업데이트
    existingStyle.titleStyle[property] = value;
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        style: existingStyle
      }
    }));
  };

  return (
    <>
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" />
            <path d="M12 16V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M12 8.01L12.01 7.99889" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          FAQ 설정
        </div>
        
        {/* FAQ 제목 설정 */}
        <div className="property-control">
          <label>FAQ 제목</label>
          <input
            type="text"
            value={selectedComponent.title || "자주하는질문"}
            onChange={(e) => handleTitleChange(e.target.value)}
            className="faq-title-input"
          />
        </div>
        
        {/* 제목 크기 설정 */}
        <div className="property-control">
          <label>제목 크기</label>
          <div className="input-with-unit">
            <input 
              type="number" 
              value={parseInt((selectedComponent.style?.titleStyle?.fontSize || '24').replace('px', ''))} 
              onChange={(e) => handleTitleStyleChange('fontSize', `${e.target.value}px`)}
              min="12"
              max="72"
            />
            <span className="unit">px</span>
          </div>
        </div>
        
        {/* 제목 정렬 설정 */}
        <div className="property-control">
          <label>제목 정렬</label>
          <select
            value={(selectedComponent.style?.titleStyle?.textAlign) || "left"}
            onChange={(e) => handleTitleStyleChange('textAlign', e.target.value)}
          >
            <option value="left">왼쪽</option>
            <option value="center">가운데</option>
            <option value="right">오른쪽</option>
          </select>
        </div>
        
        {/* FAQ 아이템 관리 */}
        <div className="property-control-section">
          <label>FAQ 항목</label>
          
          {(selectedComponent.faqItems || []).map((item, index) => (
            <div key={index} className="faq-item-edit">
              <div className="faq-item-header">
                <span>질문 {index + 1}</span>
                <button 
                  className="remove-faq-btn"
                  onClick={() => handleRemoveFAQItem(index)}
                >
                  삭제
                </button>
              </div>
              
              <div className="property-control">
                <label>질문</label>
                <textarea
                  value={item.question}
                  onChange={(e) => handleFAQItemChange(index, 'question', e.target.value)}
                />
              </div>
              
              <div className="property-control">
                <label>답변</label>
                <textarea
                  value={item.answer}
                  onChange={(e) => handleFAQItemChange(index, 'answer', e.target.value)}
                />
              </div>
            </div>
          ))}
          
          <button
            className="add-faq-btn"
            onClick={handleAddFAQItem}
          >
            질문 추가
          </button>
        </div>
      </div>
      
      {/* <PaddingControl /> */}
    </>
  );
};

export default FAQProperties; 